<ng-container>
    <div class="fw-ProfileMenu_AllSettings">
        <a (click)="navigateToSettings('/nxi/settings/allsettings')"
            class="fw-ProfileMenu_SettingsMenu text-link" tabindex="0" href="javascript:void(0)">{{'PROFILE_MENU.ALL_SETTINGS' | translate}}
            <div class="fw-ProfileMenu_SettingsIcon"></div>
        </a>
    </div>
    <ng-container *ngIf="!isSSO">
        <hr class="light fw-ProfileMenu_Borderline">
        <div class="fw-ProfileMenu_SecuritySettings">
            <a (click)="navigateToSettings('/nxi/settings/securitysettings')"
                class="fw-ProfileMenu_SettingsMenu text-link" tabindex="0" href="javascript:void(0)"> {{ 'PROFILE_MENU.SECURITY_SETTINGS' | translate}}
                <div class="fw-ProfileMenu_SecurityIcon"></div>
            </a>
        </div>
    </ng-container>
    <hr *ngIf="showDisplaySettingsMenu" class="light fw-ProfileMenu_Borderline">
    <div *ngIf="showDisplaySettingsMenu" class="fw-ProfileMenu_DisplaySettings">
        <a (click)="navigateToSettings('/nxi/settings/displaysettings')"
            class="fw-ProfileMenu_SettingsMenu text-link" tabindex="0" href="javascript:void(0)">{{ 'PROFILE_MENU.DISPLAY_SETTINGS' | translate}}
            <div class="fw-ProfileMenu_DisplayIcon"></div>
        </a>
    </div>
    <hr class="light fw-ProfileMenu_Borderline">
    <div class="fw-ProfileMenu_LastLogin" *ngIf="date && time && !hideLastLoginTime">
        <strong>{{'PROFILE_MENU.LAST_LOGIN' | translate}} </strong>
        <span class="fw-ProfileMenu_LoginDate"> {{ date }} <span class="separator">|</span> {{time}}
            {{'NXI_PORTAL_COMPONENTS.EASTERN_TIME' | translate}}</span>
    </div>
    <div *ngIf="!isSSOLogoutHide" class="fw-ProfileMenu_Logout">
        <button mat-raised-button color="primary" (click)="logout()" [disabled]="isLogoutDisabled">{{
            'PROFILE_MENU.LOGOUT' | translate}} <span class="fw-ProfileMenu_LogoutIcon"></span></button>
    </div>
</ng-container>